import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import RestlessDisplayProperty from "../../../components/common/RestlessDisplayProperty";
import RestlessDisplayLarge from "../../../components/common/RestlessDisplayLarge";
import axios from "axios";
import { fetchImageToken } from "../../../../redux/actions/imageAuth";
import { useDispatch } from "react-redux";
import { format} from 'date-fns'

export default function CommentsDetailsDialog({ row, id, show, onHide }) {
  const [gifUrl, setGifUrl] = useState("");
  const [date, setDate] = useState("");
  const dispatch = useDispatch();

  //GIF FROM GIPHY MANAGMENT
  useEffect(() => {
    const GIPHY_API_KEY = process.env.REACT_APP_GIPHY_API_KEY;
    let dateCreated = new Date(row.content.created_at);
    setDate(format(dateCreated,  "MMMM dd, yyyy"))
    
    if (!row?.gif_id) return;
    axios
      .get(
        `https://api.giphy.com/v1/gifs/${row.content.gif_id}?api_key=${GIPHY_API_KEY}`
      )
      .then((response) => {
        setGifUrl(response.data.data.images.downsized.url);
      })
      .catch((err) => console.log(err));
  }); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    dispatch(fetchImageToken);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal size="lg" show={show} onHide={onHide}>
       <Modal.Header>
        <div className="d-flex justify-content-center">Report Details</div>
        <div className="d-flex justify-content-center">Reason: {row.reason} </div>
        <div className="d-flex justify-content-center">{date}</div>
      </Modal.Header>
      <Modal.Body>
        {row && (
          <div className="container">
            <div className="row">
              <div className="col">
                <RestlessDisplayProperty label="ID" content={row.content.id} />
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Type"
                  content={row.content.poll ? "Poll" : "Text / Media"}
                />
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Source"
                  content={
                    (row?.article && "Article") ||
                    (row?.comment && "Comment") ||
                    (row.content.post && !row.content.comment && "Post")
                  }
                />
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Author"
                  content={row.content.restless_user?.full_name}
                />
              </div>
            </div>
            <hr />
            <div>
              <RestlessDisplayLarge
                label="Text"
                content={
                  row.content.body || (
                    <div className="text-muted">This comment has no text</div>
                  )
                }
              />
            </div>
            <div className="col-12">
              {row.content.gif_id && (
                <>
                  <h4 className="mb-4">Gif</h4>
                  <img
                    src={gifUrl}
                    alt=""
                    style={{
                      marginRight: "10px",
                      width: "200px",
                      height: "200px",
                      cursor: "pointer",
                    }}
                  />
                </>
              )}
            </div>
            <hr />
            <div className="row">
              <div className="col-12">
                <h4 className="mb-4">Observations</h4>
              </div>
              <div className="col">
                <RestlessDisplayProperty
                    content={row.explanation || (
                      <div className="text-muted">This report has no observations</div>
                    )}
                  />
              </div>
     
            </div>
      
            <hr />
            <div className="row">
              <div className="col-12">
                <h4 className="mb-4">Interactions</h4>
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Reactions"
                  content={row.content.info?.reactions || 0}
                />
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Comments"
                  content={row.content.info?.comments || 0}
                />
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Reports"
                  content={row.content.reports || 0}
                />
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn btn-secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
